import React, { useEffect, useState } from "react";
import StepOneMediaAgencyOnboarding from "./component/step-one-media-user-onboarding";
import ExistingUserWelcome from "./component/existing-user-welcome";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import Spinner from "@/components/ui/Spinner";
import useMediaUserOnboardingStore from "./store/mediaUserOnboardingStore";

const MediaUserOnboarding: React.FC = () => {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isTokenInvalid, setIsTokenInvalid] = useState<boolean>(false);

  const navigate = useNavigate();
  const { validateToken, inviteData } = useMediaUserOnboardingStore(
    useShallow((state) => ({
      validateToken: state.validateToken,
      inviteData: state.inviteData,
    }))
  );
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setIsTokenInvalid(true);
      return;
    }

    setIsLoading(true);
    validateToken(token).then((tokenData) => {
      if (tokenData) setIsLoading(false);
      if (!tokenData) {
        setIsLoading(false);
        setIsTokenInvalid(true);
      }
    });
  }, [searchParams, validateToken]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-screen h-screen">
        <Spinner size={30} />
      </div>
    );
  }

  if (isTokenInvalid) {
    return (
      <div className="flex flex-col justify-center items-center w-screen h-screen">
        <div className="font-bold text-2xl mb-4">Link Expired</div>
        <div>
          Oops!! Your onboarding link has been expired. Please try again later.
        </div>
      </div>
    );
  }

  // Show different screens based on whether user is existing or new
  const isExistingUser = inviteData?.is_existing_user;

  return (
    <div>
      <div className="bg-[#EA33C0] h-12"></div>
      {isExistingUser ? (
        <ExistingUserWelcome
          firstName={inviteData?.first_name || "there"}
          agencyName={inviteData?.agency_name}
        />
      ) : (
        step === 1 && (
          <StepOneMediaAgencyOnboarding
            onNext={() => {
              navigate("/dashboard?onBoardingSuccess=true");
            }}
          />
        )
      )}
    </div>
  );
};

export default MediaUserOnboarding;
